import React from 'react'
import { useTranslation } from 'react-i18next';

import { VIDEO_URL, PROJECT } from '../../constants';

import './introVideo.scss';

const IntroVideo = () => {
    const { t } = useTranslation();

    const content = PROJECT === 'vg' ? 
    {
        title: t('titleIntroVideo_vg').toUpperCase(),
        url: VIDEO_URL,
        videoTitle: 'VIVE Guardian',
    } :
    {
        title: t('titleIntroVideo').toUpperCase(),
        url: VIDEO_URL,
        videoTitle: 'VIVE Create',
    };

    return (
        <div id='intro_video' className={`row ${PROJECT}`}>
            <div className="title">{content.title}</div>
            <iframe id='video' src={content.url} title={content.videoTitle} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>  
        </div>
    )
}

export default IntroVideo;
